<style lang="stylus">
    .CreateSmartShape-mask
        modal-mask()
        .CreateSmartShape-modal
            height auto
            .CreateSmartShape-container
                position relative
                margin 16px auto 24px auto
                width 440px
                height 304px
                overflow-y auto
                border 1px solid $box-bordercolor
                border-radius 4px
                display flex
                justify-content flex-start
                .CreateSmartShape-leftbox
                    width 156px
                    height 100%
                    list-style none
                    overflow auto
                    border-right 1px solid $box-bordercolor
                    li
                        position relative
                        width 100%
                        height 60px
                        user-select none
                        cursor pointer
                        transition background-color linear .2s
                        border-bottom 1px solid $box-bordercolor
                        .item-img
                            display block
                            position absolute
                            left 0
                            top 0
                            right 0
                            bottom 0
                            margin auto
                            object-fit contain
                        &:hover
                            background-color $main-hovercolor
                .CreateSmartShape-rightbox
                    width 334px
                    height 100%
                    padding 24px
                    .rightbox-block
                        display flex
                        justify-content space-between
                        position relative
                        margin 0 auto
                        margin-bottom 24px
                        // width 166px
                        overflow auto
                        .rightbox-title
                            height 20px
                            font-size 12px
                            line-height 20px
                            color var(--text-color-black)
                            // margin-bottom 5px
                            .title-desc
                                color var(--text-color-primary)
                                opacity .5
                        .rightbox-container
                            position relative
                            width 142px
                            height 96px
                            background rgba(1,127,255,0.10)
                            border 2px dashed var(--themeColor)
                            border-radius 6px
                            display flex
                            justify-content center
                            align-items center
                            .item-img
                                width 80px
                                height 52px
                            &.plain
                                background rgba(1,127,255,0.04)
                                border-color var(--border-color-gray-10)
                        .rightbox-clear
                            position absolute
                            width 24px
                            height 24px
                            right 4px
                            top 4px
                            &:hover
                                cursor pointer
                            .item-icon
                                position absolute
                                left 0
                                top 0
                                right 0
                                bottom 0
                                margin auto
                                width 24px
                                height 24px
                    .rightbox-tips
                        // margin-left 80px
                        // margin-top 10px
                        display flex
                        justify-content flex-end
                        align-items center
                        p
                            font-size 12px
                            color var(--themeColor)
                            text-decoration underline
                            word-break break-word
                            cursor pointer
                .CreateSmartShape-dragbox
                    position absolute
                    pointer-events none
                    .item-img
                        display block
                        width 40px
                        height 26px
</style>

<template>
    <div class="CreateSmartShape-mask">
        <Dialog class="CreateSmartShape-modal" :title="$t('title')" :isShow="true" :showFooter="true" @ok="confirm" @close="cancel">
            <div ref="CreateSmartShapeContainer" class="CreateSmartShape-container">
                <ul class="CreateSmartShape-leftbox">
                    <li v-for="item in baseShapeList" :key="item.id" @mousedown="startDrag($event, item.id)">
                        <img draggable="false" class="item-img" :src="item.data" alt="" />
                    </li>
                </ul>
                <div class="CreateSmartShape-rightbox">
                    <!-- <div class="rightbox-typeBox">
                        <p class="rightbox-title">{{$t('selectType')}}</p>
                        <i-select v-model="smartShapeType" style="width: 100px" size="small">
                            <i-option v-for="type in layoutList" :value="type.id" :key="type.id">{{$t(type.text)}}</i-option>
                        </i-select>
                    </div> -->
                    <div class="rightbox-block">
                        <div class="rightbox-title">
                            <p>{{ $t("repeatElement") }}</p>
                            <p class="title-desc">（{{ $t("required") }}）</p>
                        </div>
                        <div class="rightbox-container" @mouseenter="setDragElement(1)" @mouseleave="clearDragElement()">
                            <img draggable="false" class="item-img" v-show="!!repeatElement" :src="repeatElement" alt="" />
                        </div>
                    </div>
                    <div class="rightbox-block">
                        <div class="rightbox-title">
                            <p>{{ $t("mainElement") }}</p>
                            <p class="title-desc">（{{ $t("optional") }}）</p>
                        </div>
                        <div
                            class="rightbox-container"
                            :class="{ plain: !mainElement && !hoverMainBox }"
                            @mouseenter="setDragElement(2)"
                            @mouseleave="clearDragElement()"
                        >
                            <img draggable="false" class="item-img" v-show="!!mainElement" :src="mainElement" alt="" />
                            <p v-show="!mainElement">{{ $t("dragTips") }}</p>
                        </div>
                        <div v-show="!!mainElement" class="rightbox-clear" @click="clearBox(1)">
                            <iconSymbol class="item-icon" name="smart-clear"></iconSymbol>
                        </div>
                    </div>
                    <div class="rightbox-tips">
                        <p @click="showTips">{{ $t("createTips") }}</p>
                    </div>
                </div>
                <div
                    class="CreateSmartShape-dragbox"
                    v-show="showDragbox"
                    :style="{ left: `${dragboxPosition[0]}px`, top: `${dragboxPosition[1]}px` }"
                >
                    <img draggable="false" class="item-img" :src="dragboxItem" alt="" />
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class CreateSmartShape extends Vue {
        @Inject()
        ["showMessage"];

        baseShapeList: Array<object> = [
            // {
            //     id: 0,
            //     data: 'imgurl',
            // }
        ];
        layoutList: Array<{ id: number; text: string }> = [
            {
                id: 0x1011,
                text: "layoutList.VerticalList",
            },
            {
                id: 0x1012,
                text: "layoutList.HorizontalList",
            },
            {
                id: 0x1021,
                text: "layoutList.CenterList",
            },
            {
                id: 0x1022,
                text: "layoutList.Circumference",
            },
            {
                id: 0x1023,
                text: "layoutList.SectorList",
            },
        ];
        smartShapeType: number = this.layoutList[0].id;
        showDragbox: boolean = false;
        dragboxItem: string = "";
        dragboxItemIndex: number = -1;
        repeatElement: string = "";
        repeatElementIndex: number = -1;
        mainElement: string = "";
        mainElementIndex: number = -1; // 判断拖拽到主要元素盒子还是重复元素盒子
        boxFlag: number = 0; // 1 鼠标处于repeatbox 2 鼠标处于mainbox
        selectData: Array<number> = [-1, -1]; // 用户选择的图形id
        hoverMainBox = false; // 是否在主要元素框上
        dragboxPosition: Array<number> = [0, 0];

        getIndex(id) {
            for (let i = 0; i < this.baseShapeList.length; ++i) {
                if (id == this.baseShapeList[i]["id"]) {
                    return i;
                }
            }
            return -1;
        }
        setDragElement(type) {
            if (type == 1) {
                this.repeatElementIndex = this.dragboxItemIndex;
            } else if (type == 2) {
                this.mainElementIndex = this.dragboxItemIndex;
            }
        }
        clearDragElement() {
            // 清除数据
            this.repeatElementIndex = -1;
            this.mainElementIndex = -1;
        }
        dropElement() {
            // 放下元素
            this.dragboxItem = "";
            this.dragboxItemIndex = -1;
            this.showDragbox = false;
            this.hoverMainBox = false;
            if (this.repeatElementIndex != -1) {
                this.repeatElement = this.baseShapeList[this.repeatElementIndex]["data"];
                this.selectData.splice(0, 1, this.baseShapeList[this.repeatElementIndex]["id"]);
            } else if (this.mainElementIndex != -1) {
                this.mainElement = this.baseShapeList[this.mainElementIndex]["data"];
                this.selectData.splice(1, 1, this.baseShapeList[this.mainElementIndex]["id"]);
            }
            this.clearDragElement();
        }
        startDrag(e, id) {
            let index = this.getIndex(id);
            if (index == -1) return;

            this.dragboxItemIndex = index;
            this.dragboxItem = this.baseShapeList[index]["data"];
            let baseEle = this.$refs.CreateSmartShapeContainer as HTMLElement,
                baseInfo = baseEle.getBoundingClientRect(),
                [baseLeft, baseTop] = [baseInfo["x"], baseInfo["y"]],
                startX = e.pageX - 20 - baseLeft,
                startY = e.pageY - 13 - baseTop;
            this.dragboxPosition.splice(0, 1, startX);
            this.dragboxPosition.splice(1, 1, startY);
            document.onmousemove = (ev) => {
                if (ev.pageX - e.pageX == 0 || ev.pageY - e.pageY == 0) return;
                let movex = ev.pageX - e.pageX;
                let movey = ev.pageY - e.pageY;

                this.dragboxPosition.splice(0, 1, startX + movex);
                this.dragboxPosition.splice(1, 1, startY + movey);
                this.showDragbox = true;
                // 悬浮状态检测
                this.hoverMainBox = this.mainElementIndex != -1;
            };
            document.onmouseup = () => {
                this.dropElement();
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
        clearBox(type) {
            if (type == 1) {
                this.mainElement = "";
                this.selectData[1] = -1;
                this.mainElementIndex = -1;
            }
        }
        confirm() {
            if (this.selectData[0] != -1) {
                window["_view"].createSmartShape(this.selectData, this.smartShapeType);
                this.$store.commit("setDialogState", {
                    type: "showDialog",
                    data: false,
                });
            } else {
                let msg = this.$t("needRepeatElement");
                this.showMessage({
                    type: 2,
                    time: 2,
                    imgType: 2,
                    content: msg,
                });
            }
        }
        showTips() {
            let url =
                this.lang == "zh"
                    ? "https://www.edrawmax.cn/helpcenter/web/video?uuid=df420de7f6c34be489fcf2da445db8cf&class=basic"
                    : "https://www.edrawsoft.com/guide/edrawmax/#create-smart-shape";
            window.open(url);
        }
        cancel() {}

        mounted() {}

        created() {
            let ts: any = this;
            window["_view"].getSmartShapeItem().then((e) => {
                this.baseShapeList = e.map((v: any, k) => {
                    v["data"] = URL.createObjectURL(v["data"]);
                    return v;
                });
                // 自动填充元素
                let amount = this.baseShapeList.length;
                if (amount == 1) {
                    this.repeatElement = this.baseShapeList[0]["data"];
                    this.selectData.splice(0, 1, this.baseShapeList[0]["id"]);
                } else if (amount > 1) {
                    this.repeatElement = this.baseShapeList[0]["data"];
                    this.mainElement = this.baseShapeList[1]["data"];
                    this.selectData.splice(0, 2, this.baseShapeList[0]["id"], this.baseShapeList[1]["id"]);
                }
            });
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "创建智能形状",
    "repeatElement": "重复元素：",
    "required": "必填",
    "mainElement": "主要元素：",
    "optional": "选填",
    "needRepeatElement": "重复元素不可为空",
    "createTips": "如何创建智能形状？",
    "dragTips": "将形状拖到此处",
    "selectType": "选择类型：",
    "layoutList": {
      "VerticalList": "垂直分布",
      "HorizontalList": "水平分布",
      "CenterList": "中心重叠",
      "Circumference": "中心环绕",
      "SectorList": "扇形分布"
    }
  },
  "en": {
    "title": "Create Smart Shape",
    "repeatElement": "Repeat Element:",
    "required": "Required",
    "mainElement": "Main Element:",
    "optional": "Optional",
    "needRepeatElement": "Repetitive elements cannot be empty.",
    "createips": "How do I set up smart shapes?",
    "dragTips": "Drag your shape here",
    "selectType": "Select Type:",
    "layoutList": {
      "VerticalList": "Distribute Vertically",
      "HorizontalList": "Distribute Horizontally",
      "CenterList": "Overlap in Center",
      "Circumference": "Center surround",
      "SectorList": "Fan-shaped distribution"
    }
  },
  "jp": {
    "title": "SmartShapeを作成",
    "repeatElement": "重複要素：",
    "required": "必須",
    "mainElement": "中心要素：",
    "optional": "オプション",
    "needRepeatElement": "重複要素は空にできません",
    "createTips": "スマートな図形の設定方法",
    "dragTips": "図形をここにドラッグします",
    "selectType": "タイプを選択：",
    "layoutList": {
      "VerticalList": "垂直分布",
      "HorizontalList": "水平分布",
      "CenterList": "中心に重なる",
      "Circumference": "中心で折り返し",
      "SectorList": "扇形分布"
    }
  },
  "fr": {
    "title": "Créer Forme Intelligente",
    "repeatElement": "Éléments Répétitifs:",
    "required": "Obligatoire",
    "mainElement": "Élément Principal",
    "optional": "Facultatif",
    "needRepeatElement": "Les éléments répétitifs ne peuvent pas être vides.",
    "createips": "Comment configurer des formes intelligentes ?",
    "dragTips": "Faites glisser votre forme ici",
    "selectType": "Sélectionnez le Type:",
    "layoutList": {
      "VerticalList": "Distribuer Verticalement",
      "HorizontalList": "Distribuer Horizontalement",
      "CenterList": "Chevauchement au centre",
      "Circumference": "Entourage Central",
      "SectorList": "Distribution en éventail"
    }
  },
  "de": {
    "title": "Smarte Form entwickeln",
    "repeatElement": "Wiederholendes Element:",
    "required": "Erforderlich",
    "mainElement": "Hauptelement:",
    "optional": "Optional",
    "needRepeatElement": "Wiederholte Elemente dürfen nicht leer sein",
    "createips": "Wie kann ich intelligente Formen einrichten?",
    "dragTips": "Ziehen Sie Ihre Form hierher.",
    "selectType": "Typ auswählen：",
    "layoutList": {
      "VerticalList": "Vertikel verteilen",
      "HorizontalList": "Horizontal verteilen",
      "CenterList": "Mittig überschneiden",
      "Circumference": "Mittig umkehren",
      "SectorList": "Fächerförmige Verteilung"
    }
  },
  "es": {
    "title": "Crear una forma inteligente",
    "repeatElement": "Repetir Elemento",
    "required": "Obligatorio",
    "mainElement": "Elemento principal",
    "optional": "Opcional",
    "needRepeatElement": "Los elementos repetitivos no pueden estar vacíos",
    "createips": "¿Cómo puedo configurar formas inteligentes?",
    "dragTips": "Arrastre la forma aquí",
    "selectType": "Seleccione tipo",
    "layoutList": {
      "VerticalList": "Distribuir verticalmente",
      "HorizontalList": "Distribuir horizontalmente",
      "CenterList": "Superposición en el centro",
      "Circumference": "Circunferencia central",
      "SectorList": "Distribución en forma de abanico"
    }
  },
  "pt": {
    "title": "Criar Forma Inteligente",
    "repeatElement": "Repetir Elemento:",
    "required": "Obrigatório",
    "mainElement": "Elemento Principal:",
    "optional": "Opcional",
    "needRepeatElement": "Elementos repetitivos não podem estar vazios.",
    "createips": "Como configuro formatos inteligentes?",
    "dragTips": "Arraste seu formato aqui",
    "selectType": "Selecionar Tipo:",
    "layoutList": {
      "VerticalList": "Distribuir Verticalmente",
      "HorizontalList": "Distribuir Horizontalmente",
      "CenterList": "Sobreposição ao Centro",
      "Circumference": "Orla do Centro",
      "SectorList": "Distribuição em Forma de Leque"
    }
  },
  "it": {
    "title": "Crea Smart Shape",
    "repeatElement": "Ripeti Elemento:",
    "required": "Obbligatorio",
    "mainElement": "Elemento Principale:",
    "optional": "Opzionale",
    "needRepeatElement": "Il campo per la ripetizione dell'elemento non può restare vuoto.",
    "createips": "Come si configurano le forme intelligenti?",
    "dragTips": "Trascina qui la forma",
    "selectType": "Seleziona Tipo:",
    "layoutList": {
      "VerticalList": "Distribuisci Orizzontalmente",
      "HorizontalList": "Distribuisci Verticalmente",
      "CenterList": "Sovrapponi al Centro",
      "Circumference": "Circonda Centro",
      "SectorList": "Distribuzione a Ventaglio"
    }
  },
  "tw": {
    "title": "建立SmartShape",
    "repeatElement": "重複元素:",
    "required": "必填",
    "mainElement": "中心元素:",
    "optional": "選填",
    "needRepeatElement": "重複元素不可為空",
    "createTips": "如何建立智慧圖形？",
    "dragTips": "將形狀拖曳到這裡",
    "selectType": "選擇類型：",
    "layoutList": {
      "VerticalList": "垂直分佈",
      "HorizontalList": "水平分佈",
      "CenterList": "中心重疊",
      "Circumference": "中心環繞",
      "SectorList": "扇形分佈"
    }
  },
  "kr": {
    "title": "SmartShape 만들기",
    "repeatElement": "요소 반복:",
    "required": "필수",
    "mainElement": "주 요소:",
    "optional": "선택 사항",
    "needRepeatElement": "반복 요소는 비워 둘 수 없습니다.",
    "createTips": "스마트 셰이프를 설정하려면 어떻게 해야 합니까?",
    "dragTips": "도형을 여기로 드래그하십시오",
    "selectType": "유형 선택:",
    "layoutList": {
      "VerticalList": "수직 분포",
      "HorizontalList": "수평 분포",
      "CenterList": "가운데에서 겹침",
      "Circumference": "센터 서라운드",
      "SectorList": "부채꼴 분포"
    }
  }
}
</i18n>
